import React, { useEffect, useRef, useState } from 'react';

export default function CountUp({ to = 0, prefix = '', suffix = '', duration = 1600, decimals = 0, className = '' }) {
  const [val, setVal] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting && !started.current) {
          started.current = true;
          const start = performance.now();
          const animate = (now) => {
            const p = Math.min(1, (now - start) / duration);
            const eased = 1 - Math.pow(1 - p, 3);
            setVal(eased * to);
            if (p < 1) requestAnimationFrame(animate);
          };
          requestAnimationFrame(animate);
        }
      });
    }, { threshold: 0.3 });
    obs.observe(el);
    return () => obs.disconnect();
  }, [to, duration]);

  const reduce = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const display = reduce ? to : val;
  const formatted = decimals > 0 ? display.toFixed(decimals) : Math.floor(display);

  return (
    <span ref={ref} className={className}>{prefix}{new Intl.NumberFormat('en-IN').format(formatted)}{suffix}</span>
  );
}
